var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./SeeCategoryColors.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-c95c49f4!../../node_modules/vue-loader/lib/selector?type=template&index=0!./SeeCategoryColors.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/modals/SeeCategoryColors.vue
// module id = 706
// module chunks = 0